<template>
  <div>
    <head>
      <title>Payment Failed!</title>
    </head>

    <body>
      <div class="wrapper">
        <img class="logo" src="../../../assets/images/card-payment.jpg" />

        <div class="content">
          <h2 class="normal">Payment</h2>
          <h2 class="type">Failed :(</h2>
        </div>

        <div>
          <div>
            <h2 class="normal">
              If you tried using Credit card, please try again using Debit Card.
            </h2>
          </div>

          <div class="custom-button green" @click="handleGenerateLink()">
            Try Again
          </div>

          <div>
            <a href="https://khaanpin.com.np">Continue Shopping</a>
          </div>
        </div>

        <!-- eo content -->
      </div>
      <!-- eo wrapper -->
    </body>
  </div>
</template>

<script>
import axios from "axios";
import { CartData } from "../../../services/storage.service";
export default {
  name: "FailurePage",
  data() {
    return {
      oId: CartData.getOrderId() || 0,
    };
  },
  methods: {
    handleGenerateLink() {
      if (this.oId > 0) {
        axios
          .post("https://deus.khaanpin.com/om/genpaylink/", {
            cart_id: this.oId,
          })
          .then((response) => {
            if (response.data.error == false) {
              // console.log("PaymentLink", response.data.data);
              return window.open(response.data.data, "_blank");
            }
          })
          .catch((err) => {
            console.log(err);
            this.$notification.error({
              message: "Error Generating Link",
              description: "Could Not Generate Payment Link",
            });
          });
      } else {
        this.$notification.error({
          message: "Cart Id Error",
          description: "Cart Id Not Found",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

body {
  background: #fefefe;
}
.wrapper {
  text-align: center;
  font-family: sans-serif;
  margin-top: 70px;
  margin-bottom: 6%;
}
h2 {
  font-size: 14px;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 20px;
  color: #333;
}
.logo {
  width: 150px;
  margin-top: 40px;
}
.content {
  margin-top: 10px;
}
.type {
  font-size: 24px;
  letter-spacing: 12px;
  background: red;
  padding: 10px 20px;
  color: #fff;
  display: inline-block;
}
.trans-id {
  color: red;
}
a {
  display: inline-block;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 5px;
  margin-top: 40px;
  color: #333;
}

.custom-button {
  height: 46px;
  width: 180px;
  margin: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  letter-spacing: 2px;

  &.green {
    background: #60b246;
    border-color: #60b246;
    &:hover {
      color: white;
    }
  }
  &.hide {
    display: none;
  }
}
</style>
